import React from "react";
import styled from "@emotion/styled";

const PreloaderWrapper = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	.lds-ring {
		display: inline-block;
		position: relative;
		width: 80px;
		height: 80px;
	}

	.lds-ring div {
		box-sizing: border-box;
		display: block;
		position: absolute;
		width: 64px;
		height: 64px;
		margin: 8px;
		border: 8px solid #fff;
		border-radius: 50%;
		animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
		border-color: #fff transparent transparent transparent;
	}

	.lds-ring div:nth-of-type(1) {
		animation-delay: -0.45s;
	}

	.lds-ring div:nth-of-type(2) {
		animation-delay: -0.3s;
	}

	.lds-ring div:nth-of-type(3) {
		animation-delay: -0.15s;
	}

	@keyframes lds-ring {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
`;

const PreloaderContent = styled.div<{color: string}>`
	display: inline-block;
	position: relative;
	width: 80px;
	height: 80px;

	div {
		box-sizing: border-box;
		display: block;
		position: absolute;
		width: 64px;
		height: 64px;
		margin: 8px;
		border: 8px solid ${({color}) => color};
		border-radius: 50%;
		animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
		border-color: ${({color}) => color} transparent transparent transparent;
	}

	div:nth-of-type(1) {
		animation-delay: -0.45s;
	}

	div:nth-of-type(2) {
		animation-delay: -0.3s;
	}

	div:nth-of-type(3) {
		animation-delay: -0.15s;
	}

	@keyframes lds-ring {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
`;

export const Preloader: React.FC<{color?: string}> = ({color = "#FFF"}) => (
	<PreloaderWrapper>
		<PreloaderContent color={color}>
			<div />
			<div />
			<div />
			<div />
		</PreloaderContent>
	</PreloaderWrapper>
);

const Overlay = styled.div`
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.79);
	z-index: 100;
`;

export const PagePreloader: React.FC = () => (
	<Overlay>
		<Preloader />
	</Overlay>
);
